import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useLenis } from "@/lib/useLenis";
import { ChatWidget } from "@/components/ChatWidget";
import Home from "@/pages/Home";
import Resources from "@/pages/Resources";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import SignContract from "@/pages/SignContract";

function App() {
  useLenis();

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/sign-contract/:token" element={<SignContract />} />
        </Routes>
        <ChatWidget />
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
